



































import { Vue, Prop, Component } from "vue-property-decorator";
import { WorkerImport as IWorkerImport } from "@/api-v2/labor-protection/models/worker-import";
import TextField from "@/components/form/CustomPage/textField.vue";
import ImportErrorList from "@/components/imports/ImportErrorList.vue";
import { getFileName } from "@/utils/files-helper";

@Component({
  components: { ImportErrorList, TextField }
})
export default class ImportLaborWorkerDetail extends Vue {
  @Prop() importData!: IWorkerImport & { file: { url: string } };

  get fileName() {
    return getFileName(this.importData?.file);
  }
}
